module.exports = __webpack_public_path__ + "img/tr.ffeaeaa6.svg";